export const dictionary_fr = {
    "Total Credits": "Crédits totaux",
    "Remaining Credits": "Crédits restants",
    "Extra Fuel Charge": "Frais de carburant supplémentaires",
    "Next": "Suivant",
    "_minimumPerOrder": "Pour continuer à la caisse, votre commande doit être supérieure à ",
    "Log In": "Se connecter",
    "Delivery": "Livraison",
    "Subtotal": "Sous-total",
    "Tax": "Taxe",
    "Credits": "Crédits",
    "Total": "Total",
    "STORE": "BOUTIQUE",
    "CART": "PANIER",
    "Cart": "Panier",
    "Item": "Article",
    "Items": "Articles",
    "Contact Us": "Nous contacter",
    "Log Out": "Se déconnecter",
    "My Account": "Mon compte",
    "Store": "Boutique",
    "Close": "Fermer",
    "_StartAddingItems": "Commencer l'ajout d'items",
    "Items for": "Articles pour",
    "Items for Purchase": "Articles en vente",
    "Existing Order": "Commande existante",
    "Additional Order": "Commande supplémentaire",
    "Continue Browsing": "Continuez à naviguer",
    "_SelectVariationForItem": "SVP sélectionner une variation",
    "_SelectScheduleForShare": "SVP sélectionner une fréquence de livraison",
    "Add": "Ajoutez",
    "Try Again": "Réessayez",
    "Something went wrong": "Quelque chose n'a pas fonctionnée",
    "_LoseYourChanges": "En quittant vous perdrez toutes vos modifications",
    "Leave": "Quitter",
    "Stay": "Rester",
    "Login with Facebook": "Se connecter avec Facebook",
    "or": "ou",
    "Login with Email": "Connection avec un courriel",
    "email": "courriel",
    "Email": "Courriel",
    "password": "mot de passe",
    "Password": "Mot de passe",
    "Forgot Password": "Mot de passe oublié",
    "Not a member yet?": "Pas encore membre ?",
    "New Member": "Nouveau membre ?",
    "Summary_Account.join": "cliquez pour adhérer",
    "Create an Account": "Créer un compte",
    "_LoginToStart": "SVP vous connecter pour sélectionner des items",
    "Login": "Se connecter",
    "Loading": "Chargement en cours",
    "Sign Up": "S\u0027inscrire",
    "pickupSiteNotAvailableForSubscription": "Ce lieu n\u0027est pas disponible car il n\u0027y a pas de livraison planifié pour vos souscriptions concernant ce lieu.",
    "pickupSiteNotChangeDistributionDay": "Pour le moment, vous ne pouvez modifier votre jour de livraison pour DELIVERY_DAY. SVP nous contacter pour effectuer ce changement.",
    "guestStoreClosedSeasonEnd": "Ce lieu n\u0027est pas disponible pour l\u0027instant car nous avons déjà commencé à préparer des livraisons correspondantes.",
    "cantAcceptChangesActiveOrder": "Votre requête ne peut pas aboutir car vous avez actuellement une distribution programmée en cours. ",
    "cantUpdatePermanentHold": "You currently cannot put your subscription on hold.\u003cbr /\u003ePlease try again after {0}",
    "pickupSiteNotAvailablePrepareDeliveries":"Vous pouvez modifier votre commande pour ce point de chute entre ",
    "pick-up site":"Point de chute",
    "pickupDayStepHeader": "Choisissez un point de chute disponible dans la liste ou la carte.",
    "waitlist only": "liste d\u0027attente uniquement",
    "More":"Plus",
    "more":"plus",
    "Waitlist Locations": "Lieux sur liste d\u0027attente",
    "Waitlist Location": "Lieu sur liste d\u0027attente",
    "comments": "Commentaires",
    "Delivery Day": "Jour de livraison",
    "Available Location": "Lieu disponible",
    "Available Locations": "Lieux disponibles",
    "pickupSiteMapDetails":"Sélectionnez un lieu de collecte disponible à partir de la liste ou de la carte",
    "Select this location": "Sélectionner ce lieu",
    "Back": "Retour",
    "BACK": "RETOUR",
    "Finish": "Terminer",
    "checkout": "Passer à la caisse",
    "Checkout": "Paiement",
    "SHOP":"Magasinez",
    "_WaitListLabel": "Notre ASC est complète actuellement. Veuillez vous ajouter à la liste d\u0027attente en sélectionnant une part.",
    "_NoShares": "Aucune part n\u0027\u0027est disponible pour le lieu de collecte sélectionné. Veuillez envoyer un courriel à FARM_EMAIL pour plus d\u0027\u0027information.",
    "_ContinueNextToCompleteSignupProcess": "SVP procéder à l'étape suivante pour compléter votre inscription.",
    "Existing": "existante",
    "Additional" : "supplémentaire",
    "Select schedule": "Choisissez une option",
    "_AgreeToTerms": "Vous acceptez les termes et conditions ",
    "Create Account": "Créer un compte",
    "Create account with Facebook": "Créez compte avec Facebook",
    "Create account with Email": "Créez compte avec courriel",
    "All": "Tout",
    "Filter by day": "Filtrer par journ\xE9e",
    "Filter by zip code": "Filtrer par code postal valide",
    "Search": "search",
    "Search by zip code": "Search par code postal valide",
    "State": "Pays",
    "_ZipCodeError": "SVP entrer un code postal valide",
    "_AddressError": "SVP entrer une addresse valide",
    "LIST": "LISTE",
    "MAP": "CARTE",
    "Email Address": "Adresse courriel",
    "Choose a Password": "Choisissez un mot de passe",
    "Retype Password": "Confirmez le mot de passe",
    "First Name": "Prénom",
    "Last Name": "Nom",
    "Primary Phone": "Téléphone principal",
    "Secondary Phone": "Téléphone secondaire",
    "Address Line 1": "Adresse ligne 1",
    "Address Line 2": "Adresse ligne 2",
    "City": "Ville",
    "Zip/Postal Code": "Code postal",
    "Additional Contact": "Contact supplémentaire",
    "Phone": "Téléphone",
    "alsoSendComEmail": "Envoyer les courriels à ce contact également",
    "Summary": "Résumé",
    "First Distribution": "Première distribution",
    "Delivery Option": "Option de livraison",
    "Totals": "Totaux",
    "Secured Payment & Privacy Protection": "Paiements sécurisés et Protection de la vie privée",
    "Qty": "Quantité",
    "Shares": "Paniers",
    "Options": "Options",
    "Terms": "Termes",
    "Contact Info": "Coordonnées",
    "Pay": "Payer",
    "Total due at checkout": "Montant total dû",
    "Manage Payments": "Gérer les paiements",
    "Balance": "Balance",
    "Change": "Changer",
    "Subscription": "Abonnement",
    "Overview": "Vue d'ensemble",
    "Pick-up direction": "Instructions pour la collecte",
    "Delivery Hold": "Suspendre livraisons",
    "From": "De",
    "To": "à",
    "Save": "Sauvegarder",
    "Date": "Date",
    "Description": "Description",
    "Debit": "Débit",
    "Credit": "crédit",
    "Cancel": "Annuler",
    "_DeliveryHoldInstruction": "SVP cliquer les cases 'De' et 'À' pour choisir les dates ",
    "want a delivery": "vous voulez une livraison",
    "Directions to Your Site": "Indication vers votre point de chute",
    "Your contact information": "Vos informations de contact",
    "_SelectAvailableDelivery": "Choisissez un point de chute pour la collecte",
    "Change Delivery Option": "Changez vos options de livraison",
    "Select Payment Amount": "Selectionnez le montant que vous voulez payer",
    "Automatic renewal charges": "Frais de renouvellement automatique",
    "Update details": "Valider les informations",
    "Update payment details": "Valider les informations de paiement",
    "Change Subscription": "Modifier la souscription",
    "CANCEL": "ANNULER",
    "SAVE": "SAUVEGARDER",
    "NOT": "NON",
    "Pick-up Directions": "Votre Point chute",
    "Pickup Directions": "Indications pour collecte",
    "Site Host Contact Information": "Informations de contact du représentant de la ferme",
    "More Info": "En savoir plus",
    "How to Find Your Box": "Comment choisir votre format de panier",
    "_StoreOrderDistribution": "Répartition des commandes",
    "Next Distribution": "Distribution suivante",
    "_ScheduledDistributionInProcess": "Votre requête ne peut être complétée car vous avez une commande active.",
    "per delivery": "par livraison",
    "Additions": "Ajouts",
    "Special Discount": "Rabais spécial",
    "Web Order": "Commande en ligne",
    "FatalError.text": "Désolé, mais un problème est survenu.",
    "creditNotUsed": "Vous n\u0027avez pas utilisé l\u0027ensemble de votre",
    "enterValidVacationRangeNotOverlap": "Veuillez définir vos périodes d\u0027arrêt de livraison de sorte qu\u0027elles ne se chevauchent pas.",
    "enterFutureVacationPeriod": "Veuillez définir votre période d\u0027arrêt de livraison afin que les dates ne soient pas dans le passé.",
    "enterValidVacationRange": "Veuillez définir votre période d\u0027arrêt de livraison de telle sorte que la date de début soit avant la date de fin.",
    "noChangeAllowedVacation": "Les changements aux dates de vacances affectent des livraisons à venir et ne peuvent être acceptés.\u003cbr /\u003eSVP essayez de nouveau. ",
    "storeClosedChangeVacation": "Delivery hold for the next delivery day until after ",
    "_OrderScheduledDuringTheseDates": "Vous avez une livraison prévue à ces dates. Cliquez 'Sauver' pour sauvegarder les dates de suspension et annuler la commande ou cliquer 'Annuler' pour ignorer les dates de suspension.",
    "cantAcceptVacationChangeActiveOrder": "Vous avez actuellement une commande programmée dans ces dates. Veuillez contacter le producteur pour la modification.",
    "sendEmailsRequiresFields": "Pour envoyer un message au conjoint/partenaire, veuillez compléter les champs Prénom, Nom et Adresse courriel ",
    "INVALID_PHONE_NUMBER": "Entrer un nombre à 10 chiffres",
    "INVALID_ADDRESS_HOME_DELIVERY": "Your home address can't be verified. Please click 'Cancel' to return to your account and update your address in the Contact Info tab.",
    "AUTHORIZE_DOT_NET": "Carte de débit ou de crédit",
    "Learn More": "En savoir plus",
    "credits": "Crédits",
    "Select variation": "Sélectionner une variation",
    "_thankYouSignUpWaitlistTitle": "Merci de vous être inscrit à notre liste d\u0027attente!",
    "_thankYouSignUpWaitlistBody": "Nous communiquerons avec vous dès que des places se libéreront.",
    "_thankYouTitle": "Merci!",
    "_thankYouBody": "Merci. Votre commande a été enregistrée. Vous recevrez bientôt un courriel qui confirmera votre commande et résumera votre sélection.",
    "_thankYouDeclinedTitle": "This transaction has been declined",
    "_thankYouDeclinedBody": "Please return and try again.",
    "_thankYouUpdatePaymentDetailsTitle": "Update Payment Details",
    "_thankYouUpdatePaymentDetailsBody": "Vos modalités de paiements ont été mises à jour correctement.",
    "_thankYouPaymentTitle": "Merci pour votre paiement !",
    "_thankYouPaymentBody": "Nous vous avons envoyés un courriel avec une confirmation de votre paiement.",
    "_thankYouChangeSubscriptionTitle": "Merci ! Votre abonnement a été mis à jour",
    "_thankYouChangeSubscriptionBody": "Nous vous avons envoyés un courriel avec un résumé et une confirmation du changement de votre abonnement.",
    "_thankYouSignUpTitle": "Merci!",
    "_thankYouSignUpBody": "Votre inscription a été enregistrée. Vous recevrez bientôt un courriel de confirmation détaillé de votre inscription.",
    "Back to Store": "Retour à la boutique",
    "Back to store": "Retour à la boutique",
    "Back to Account": "Retour à mon compte",
    "_waitListSubscriptionTitle": "Déjà sur la liste d\u0027attente",
    "_waitListSubscriptionBody": "Il semble que vous ayez déjà une demande de liste d\u0027attente dans notre système. Veuillez vous connecter à votre compte pour voir les détails de votre demande de liste d\u0027attente.",
    "_subscriptionExistsTitle": "Abonnement déjà existant",
    "_subscriptionExistsBody": "Il semble que vous soyez déjà abonné dans notre système. Veuillez vous connecter à votre compte pour voir les détails de votre abonnement.",
    "_noSubscriptionTitle": "Aucun abonnement",
    "_noSubscriptionBody": "Pour que votre commande puisse être traitée, vous devez être abonné auprès du producteur.\u003cbr/\u003eVeuillez communiquer avec le producteur ou visiter notre site Web pour vous inscrire.",
    "_holdSubscription_ADMIN_title": "Abonnement suspendu",
    "_holdSubscription_ADMIN_body": "Désolé, mais votre abonnement est actuellement suspendu. Veuillez communiquer avec le producteur pour rétablir votre abonnement afin que nous puissions traiter votre commande.",
    "_subscriptionCanceledTitle": "Abonnement annulé",
    "_subscriptionCanceledBody": "Désolé, mais votre abonnement a été annulé. Veuillez communiquer avec le producteur pour rétablir votre abonnement afin que nous puissions traiter votre commande.",
    "_holdSubscription_NEW_title": "Ouverture de votre compte",
    "_holdSubscription_NEW_body": "Merci de vous être abonné! Nous sommes en train d\u0027ouvrir votre compte. Veuillez visiter notre magasin en ligne de nouveau dans quelques jours. ",
    "_holdSubscription_VACATION_AllowChangeTitle": "Vacances prévues",
    "_holdSubscription_VACATION_AllowChangeBody": "Nos dossiers indiquent que vous avez des vacances prévues. Pour modifier vos paramètres de vacances, veuillez accéder à votre compte.",
    "_noFutureDeliveriesTitle": "Aucune livraison prévue",
    "_noFutureDeliveriesBody": "Désolé, mais aucune livraison n\u0027est prévue à votre lieu de collecte.",
    "_holdSubscription_VACATION_title": "Vacances prévues",
    "_holdSubscription_VACATION_body": "Nos dossiers indiquent que vous avez des vacances prévues. Veuillez communiquer avec le producteur pour changer vos paramètres de vacances.",
    "_storeWaitListSubscriptionTitle": "Abonnement en liste d\u0027attente",
    "_storeWaitListSubscriptionBody": "Il semble que votre abonnement soit en liste d\u0027attente.\u003cbr\u003ePour que votre commande puisse être traitée, vous devez être abonné auprès du producteur.",
    "_processingOrderTitle": "Votre demande est en cours de traitement",
    "_processingOrderBody": "Le système essaie actuellement de traiter votre demande. Si vous ne recevez pas un courriel de confirmation, veuillez réessayer dans 15 minutes.",
    "Store Closed": "Magasin fermé",
    "Make Single Payment": "Effectuez un paiement unique",
    "Make Payment": "Effectuez un paiement",
    "Automatic Renewal Charges": "Frais de renouvellement automatique",
    "Auto Charges": "Frais de renouvellement",
    "Update Details": "Valider les informations",
    "Update": "Mettre à  jour",
    "CHECK": "Chèque",
    "BALANCE": "Balance",
    "Add Coupon": "Ajouter un coupon",
    "invalidCoupon":"Le coupon inscrit n'est pas valide",
    "invalidSubscriptionMinCoupon":"To redeem the coupon your shares value should exceed ${0}. Continue sign-up without the coupon or click back to choose another share.",
    "invalidSubscriptionMinCouponWithOptions":"To redeem the coupon your shares and options value should exceed ${0}. Continue sign-up without the coupon or click back to choose another share or option.",
    "NotFirstOrderOfSubscription":"Le coupon est valide uniquement pour la première commande",
    "AlreadyUsedBySubscription": "Ce code de coupon a déjà été utilisé",
    "Apply": "Appliquer",
    "PaymentPlanStep.heading": "Choisissez votre plan de paiement",
    "Payment Plan": "Plan de paiement",
    "Price": "Prix",
    "Notes": "Remarques",
    "promotionalCode": "Option - code promotionnel",
    "Coupon Code": "Code coupon",
    "Remove": "Supprimer",
    "PHONE": "Autre",
    "PAYPAL_STANDARD": "PayPal",
    "PAYPAL_PREAPPROVE": "Paiement automatique récurrent - PayPal",
    "ELECTRONIC_CHECK": "Chèque électronique",
    "ELECTRONIC_CHECK_PREAPPROVE": "Paiement automatique récurrent - Chèque électronique ",
    "AUTHORIZE_DOT_NET_PREAPPROVE": "Paiement automatique récurrent - Carte de crédit or de débit",
    "CASH": "Comptant à la livraison",
    "_paymentSuccessfullyUpdated": "Vos informations de paiement ont été enregistées.",
    "NONE": "Aucun",
    "Update Payment Plan": "Mise à jour du mode de paiement",
    "_planSuccessfullyUpdated": "Votre mode de paiement a été mis à jour.",
    "Charge Member": "Frais chargé au membre",
    "_successfullyCharged": "Les frais ont été chargés au membre.",
    "_refreshTheDashboard": "SVP rafraîchir le tableau de bord pour visualiser les changements.",
    "Product Details": "Détails du produit",
    "About the producer": "Au sujet du producteur",
    "_CheckOutMessageBalance": "Le montant de votre commande sera porté sur votre compte. Veuillez regarder votre boîte de courriel pour un message qui confirmera votre commande et contenirait des directives supplémentaires.",
    "_CheckOutMessageNone": "Après avoir cliqué sur le bouton « \u003cb\u003ePlace Order\u003c/b\u003e », _FARM_NAME_ commencera le traitement de votre sélection.",
    "ON_DELIVERY_CHARGE_hasToken": "Après avoir cliqué sur le bouton « \u003cb\u003ePlace Order\u003c/b\u003e », nous commencerons de traiter votre commande. Vous serez facturé après la livraison de votre commande selon l\u0027\u0027information de paiement qui figure déjà dans votre fichier.",
    "_chargeHasTokenZeroAmount": "En cliquant sur le bouton \"\u003cb\u003ePlacer commande\u003c/b\u003e\" nous traiterons votre commande.",
    "_ItemShort": "En raison de bris d'inventaire nous ne pouvous compléter votre commande ",
    "_checkoutWithTheAvailableItems": " Vous pouvez terminer votre commande avec les items de la liste ou retourner dans le magasin de la liste ou retourner dans le magasin pour compléte.",
    "_OrderWasntCreated": "La commande n'a pas été créée",
    "returnToStore": "Retour à la boutique",
    "Place Order": "Placer commande",
    "Finalize Your Order": "Complétez votre commande",
    "By clicking": "En cliquant",
    "_agreeToTerms": "Vous acceptez les termes et conditions ",
    "_usingPaymentDetailsOnFile": "Payer en utilisant les informations de paiement au dossier",
    "_AutomaticallyRecurringPayments": "Paiement automatique récurrent",
    "_optionRemove": "Supprimer les détails de paiement",
    "_optionRemoveAutomatic": "Supprimer les détails automatiques de paiement",
    "Payment Method": "Mode de paiement",
    "paymentMethodReuse": "Nous utilisons la sélection de votre inscription",
    "paymentMethodMessage": "Comment souhaitez-vous régler ?",
    //"_CheckOutMessageCheck": "Cliquer sur le bouton « \u003cb\u003e----\u003c/b\u003e » pour passer votre commande. Ensuite veuillez envoyer un chèque pour le montant de votre commande à _FARM_NAME_.",
    "ON_DELIVERY_CHARGE_noToken": "Vous serez facturé après la livraison de votre commande.  Après avoir cliqué sur le bouton « \u003cb\u003e_BUTTON_TITLE_\u003c/b\u003e », vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de paiement.",
    "AUTHORIZE_DOT_NET_MESSAGE": "Après avoir cliqué sur le bouton « \u003cb\u003e_BUTTON_TITLE_\u003c/b\u003e », vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de crédit et votre autorisation.",
    "AUTHORIZE_DOT_NET_store": "Après avoir cliqué sur le bouton « \u003cb\u003e_BUTTON_TITLE_\u003c/b\u003e », vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de crédit. Un paiement sera porté sur votre carte de crédit/débit pour effectuer votre commande.",
    "AUTHORIZE_DOT_NET_PREAPPROVE_reuse": "Nous acceptons le paiement automatique pour votre commodité. Après avoir cliqué sur le bouton « \u003cb\u003e_BUTTON_TITLE_\u003c/b\u003e », nous débiterons votre carte de crédit automatiquement selon le plan de paiement choisi.",
    "MASSAGE.AUTHORIZE_DOT_NET_PREAPPROVE": "Selon votre plan de paiement sélectionné, un paiement sera porté automatiquement sur votre carte de crédit/débit pour remplir votre compte avec {1}.<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de paiement.",
    "AUTHORIZE_DOT_NET_PREAPPROVE_seasonal": "Selon votre plan de paiement sélectionné, un paiement sera porté sur votre carte de crédit/débit selon le programme de paiements automatiques.<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de paiement.",
    "MASSAGE.CASH": "Cliquer sur le bouton « \u003cb\u003e{0}\u003c/b\u003e » pour finir votre inscription. Veuillez préparer votre paiement avant le date de livraison. Regardez votre boîte de courriel pour plus de directives.",
    "MASSAGE.CHECKS": "Cliquer sur le bouton \"<b>{0}</b>\" pour finir votre inscription. Les directives pour la préparation du chèque vous seront envoyées par courriel.",
    "MASSAGE.CHECK": "Cliquer sur le bouton \"<b>{0}</b>\" pour passer votre commande. Ensuite veuillez envoyer un chèque pour le montant de votre commande à {1}.",
    "MASSAGE.ELECTRONIC_CHECK": "Si vous avez un compte bancaire, veuillez soutenir-nous en sélectionnant ce mode de paiement. Le frais de transaction est moins des autres modes de paiement électronique.<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site sécurisé pour entrer vos informations de paiement.",
    "MASSAGE.ELECTRONIC_CHECK_store": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de compte bancaire. Un paiement sera porté sur votre compte pour effectuer votre commande.",
    "ELECTRONIC_CHECK_PREAPPROVE_reuse": "Nous acceptons le paiement automatique pour votre commodité. Après avoir cliqué sur le bouton \"<b>{0}</b>\", nous débiterons votre compte bancaire automatiquement selon le plan de paiement choisi.",
    "MASSAGE.ELECTRONIC_CHECK_PREAPPROVE": "You will be charged according to the payment plan that you have selected to refill your account balance with {1}. This is a preferred payment due to a lower transaction fee in comparison to other electronic payment methods.",
    "ELECTRONIC_CHECK_PREAPPROVE_seasonal": "Selon votre plan de paiement sélectionné, un paiement sera porté sur votre compte bancaire selon le programme de paiements automatiques<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de paiement.",
    "MASSAGE.PAYPAL_STANDARD": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers au site de PayPal où vous pouvez payer en sécurité.",
    "MASSAGE.PAYPAL_STANDARD_store": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers au site de PayPal où vous pouvez payer en sécurité. Un paiement sera porté sur votre compte pour effectuer votre commande.",
    "PAYPAL_PREAPPROVE_reuse": "Nous acceptons le paiement automatique pour votre commodité. Après avoir cliqué sur le bouton \"<b>{0}</b>\", nous débiterons votre compte PayPal automatiquement selon le plan de paiement choisi.",
    "PAYPAL_PREAPPROVE_store": "Basé sur le mode de paiement que vous avez choisi, votre compte PayPal sera chargé automatiquement pour renflouer votre compte… En cliquant sur le  bouton {0}, vous serez redirigé vers PayPal pour définir vos options de paiement. Vous aurez besoin d'un compte PayPal pour compléter la transaction. Vous pourrez créer un compte PayPal lors de la prochaine étape.",
    "PAYPAL_PREAPPROVE_seasonal": "Basé sur le mode de paiement que vous avez choisi, votre prochain paimement récurant de .<br/> En cliquant sur le bouton \"<b>{0}</b>\" ,vous serez redirigé vers PayPal où vous pourrez configurer votre paiement. Vous aurez besoin d'un compte PayPal pour compléter la transaction. Vous pourrez créer un compte PayPal lors de la prochaine étape.",
    "MASSAGE.PHONE": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", {1} commencera le traitement de votre sélection. Veuillez communiquer avec le producteur au {2} pour obtenir des renseignements sur la facturation.",
    "_contactToFarm1": "Si vous devez contacter la ferme, SVP envoyez un courriel à ",
    "_contactToFarm2": "Ou visitez le site web à ",
    "_contactToFarm3": "pour plus d'informations.",
    "Order Exists": "Commande existante",
    "_haveOrderThatIsBeingProcessed": "Vous avez déjà une commande en traitement. Cliquez sur \"Ajouter items\" pour ajouter de nouveaux items.",
    "_multiOrderStoreClosed":"We are currently preparing orders for {0}, but the store is wide open for {1}. Please send an email to {2} if you're experiencing difficulty.",
    "Add Items": "ajouter des articles",
    "_contactTheFarm": "Veuillez contacter le producteur pour de plus amples informations.",
    "_seasonEnded": "La saison {0} est déjà terminée. ",
    "_noSubscription": "Vous n'avez pas d'abonnement ",
    "Please click": "SVP cliquer",
    "here": "ici",
    "_setYourSubscription": "pour vous inscrire et choisir votre abonnement.",
    "subscriptionCanceled": "Votre souscription est annulée.",
    "storeClosed": "Désolé, mais le magasin en ligne est fermé. Il rouvrira à partir de {0} pour que vous puissiez passer votre commande.",
    "storeClosedNoHours": "Désolé, mais le magasin en ligne est fermé.",
    "Start Shopping": "Commencer à magasiner",
    "Waitlist": "liste d'attente",
    "Pick-Up Site": "Point de chute",
    "Distributions": "Distributions",
    "selectPickupSiteSummary": "Veuillez sélectionner {0}",
    "selectShare": "SVP sélectionner au moins un format de panier.",
    "Continue": "Continuer",
    "CONTINUE": "CONTINUER",
    "noChangeAllowed1": "Le producteur prépare actuellement votre prochaine livraison. Veuillez revenir après {0} pour faire des changements.",
    "_assignedAutomaticPayment": "Présentement configuré pour les paiements automatiques de ",
    "removeAutomaticPaymentConfirmation": "Souhaitez-vous vraiment supprimer le paiement automatique pour ce membre ?",
    "Member is": "Le membre est",
    "Preview": "Aperçu",
    "You are": "Vous êtes",
    "_NoShares1": "Aucune part n\u0027\u0027est disponible pour le lieu de collecte sélectionné. Veuillez envoyer un courriel à ",
    "_NoShares2": " pour plus d\u0027\u0027information.",
    "Please enter email address": "Veuillez saisir adresse courriel",
    "Please enter first name": "Veuillez saisir prénom",
    "Please enter last name": "Veuillez saisir nom",
    "Please enter primary phone": "Veuillez saisir téléphone principal",
    "Please enter address line": "Veuillez saisir adresse ligne",
    "Please enter zip/postal code": "Veuillez saisir code postal",
    "Please enter city": "Veuillez saisir ville",
    "Please enter at least 6 characters": "Veuillez saisir au moins 6 caractères",
    "Please retype your password": "Confirmez le mot de passe",
    "Invalid email": "Veuillez saisir un email valide",
    "The password does not match": "La confirmation ne concorde pas",
    "Invalid zip code": "Veuillez saisir un zip code valide",
    "Submit": "Soumettre",
    "Back to Login": "Retour à la Se connecter",
    "noAccount": "Aucun compte ne correspond à cette adresse courriel",
    "Please fill Email": "Veuillez saisir adresse courriel",
    "Incorrect password": "Le mot de passe est incorrect",
    "Password is required": "Mot de passe requis",
    "Jan":"Janv",
    "Feb":"Févr",
    "Mar":"Mars",
    "Apr":"Avril",
    "May":"Mai",
    "Jun":"Juin",
    "Jul":"Juil",
    "Aug":"Août",
    "Sep":"Sept",
    "Oct":"Oct",
    "Nov":"Nov",
    "Dec":"Déc",
    "Sunday":"Dimanche",
    "Monday":"Lundi",
    "Tuesday":"Mardi",
    "Wednesday":"Mercredi",
    "Thursday":"Jeudi",
    "Friday":"Vendredi",
    "Saturday":"Samedi",
    "_receiveReminders": "Je souhaite recevoir des rappels par courriel",
    "Powered By": "Fourni Par",
    "_enterContactInfo": "Veuillez saisir vos informations de contact",
    "_refreshOrderDeleted":"Order does not exist, need to refresh the page",
    "_syncOptionSchedulesValidation":"Please update the schedule selected for {0} to correspond with the schedule/s assigned to your share/s.",
    "Back to Cart": "Back to Cart",
    "_setSubscriptionOnPermanentHold":"Place my subscription on permanent hold",
    "_createAccountBottomNote": "Cliquez sur les liens ci-dessus pour créer un compte avec Facebook ou avec une adresse courriel. Si vous avez déjà un compte, cliquez sur l'onglet \"Se connecter\".",
    "starts on": "Débute",
    "VacationHoldTopLine": "Entrez les plages de dates pour lesquelles vous désirez suspendre les livraisons.",
    "VacationHold2ndLine": "Votre prochaine livraison est prévue le"
};




// WEBPACK FOOTER //
// ./src/i18n/dictionary_fr.js